export default "https://cdn-gra-staging.amplement.io/statics/images/empty-image-196x196.png";